/**
 * The agent's "Add connector" list, as pure functions: which of the
 * organization's entries it shows for a search, in which order, and what
 * each one asks before it can be added. Nothing is ever chosen for the
 * person — the list has no selection, only an Add per entry (2026-10-21:
 * the old dropdown pre-selected the first entry, so one click on "Connect"
 * added a connector nobody chose). `tests/unit/connector_library/
 * agent_browse.test.mjs` runs the real code.
 */

import { matches, type Kind } from './libraryList';

export interface BrowseEntry {
  entry_id: string;
  kind: Kind;
  name: string;
  description?: string | null;
  added: boolean;
  needs_credential: boolean;
}

/** The entries of the kinds this organization switched on that match the
    search, in the server's order (nearest organization first, then by name). */
export function browse<T extends BrowseEntry>(entries: T[], query: string, kinds: Kind[]): T[] {
  return entries.filter(e => kinds.includes(e.kind) && matches(e, query));
}

/** What adding one takes: nothing more, its own token first, or nothing at all (already on the agent). */
export type AddStep = 'added' | 'token' | 'ready';
export function addStep(entry: BrowseEntry): AddStep {
  if (entry.added) return 'added';
  return entry.needs_credential ? 'token' : 'ready';
}
